module.exports = __webpack_public_path__ + "static/img/C (32).976daf84.png";